import React from "react"

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container fw">
        <a href="/" className="footer__logo" aria-label="Jason Clixby, home">
          Jason Clixby <span>.</span>
        </a>
        <ul className="footer__links">
          <li><a href="/#services">Services</a></li>
          <li><a href="/#about">About</a></li>
          <li><a href="/#contact">Contact</a></li>
        </ul>
        <p className="footer__copyright">&copy; {year} Jason Clixby. All rights reserved.</p>
      </div>
    </footer>
  )
}